import React from "react";
import Style from "./FinalProductList.module.css";
import { separate } from "../../Functions/NumberSeprator";

const FinalProductList = ({ data }) => {
  console.log(data);
  let newTotalPrice = null;
  let totalPrice = null;
return (
    <div className={Style.factorHolder}>
      <h1 className={Style.title}>فاکتور نهایی</h1>
      <ul className={Style.StyleList}>
        {data.filter(value=>{
            totalPrice = totalPrice + (parseInt(value.price)*value.count);
            if(value.availability==="1"){
                return value
            }else return false
        })
        .map((item) => {
            newTotalPrice = newTotalPrice + (parseInt(item.new_price)*item.new_count);
          return (
            <li className={Style.ShoppingList}>
              <div className={Style.topHold}>
                <p>
                  {" "}
                  {item.name} <span>({item.new_count} عدد)</span>{" "}
                </p>
                <div className={Style.PriceList}>
                  <strong >
                    {(separate(item.new_price*item.new_count))}
                    <span>تومان</span>
                  </strong>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <div className={Style.total}>
        <h2 className={Style.totalPrice}>مجموع قیمت قدیم: </h2>
        <h2 className={Style.price} style={{color:"red",textDecoration:"line-through"}}>
          {separate(totalPrice)} <span className={Style.toman}>تومان</span>
        </h2>
      </div>
      <div className={Style.total}>
        <h2 className={Style.totalPrice}>مجموع قیمت جدید: </h2>
        <h2 className={Style.price} style={{color:"green"}}>
          {separate(newTotalPrice)} <span className={Style.toman}>تومان</span>
        </h2>
      </div>
    </div>
  );
};

export default FinalProductList;
